import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { ConservazioneCaricaDocumentoRegistroUnicoIvaStep2Component } from './conservazione-carica-documento-registro-unico-iva-step2';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('home.conservazione-carica-documento-registro-unico-iva-step2', {
            url: '/conservazione-carica-registro-unico-iva',
            ncyBreadcrumb: {
                label: 'Carica Registro Unico Iva',
                parent: 'home.conservazione'
            },
            data: {
                authorisationLevel: 1,
                pageTitle: 'Conservazione Carica Documento'
            },
            'views': {
                'homeContent': {
                    template: '<conservazione-carica-documento-registro-unico-iva-step2 flex="100"></conservazione-carica-documento-registro-unico-iva-step2>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const ConservazioneCaricaDocumentoRegistroUnicoIvaStep2Module: string = ng
    .module('conservazione-carica-documento-registro-unico-iva-step2', [
        'ui.bootstrap',
        uiRouter,
    ])
    .component('conservazioneCaricaDocumentoRegistroUnicoIvaStep2', ConservazioneCaricaDocumentoRegistroUnicoIvaStep2Component)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/conservazione-carica-documento-registro-unico-iva-step2/conservazione-carica-documento-registro-unico-iva-step2.module.ts